module.exports = __webpack_public_path__ + "static/media/arbejdsomraadekurser.ffd8a103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Courses/arbejdsomraadekurser.jpg
// module id = 1524
// module chunks = 0